import { useEffect } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { CheckoutFormValues } from '../types';

/**
 * Rozpracovaný formulář v sessionStorage — VAT stav přežívá refresh na serveru
 * (e_checkout_vat_state), takže vyplněná pole ho musí přežít taky, jinak po
 * refreshi visí hláška o plátci DPH nad prázdným formulářem.
 */

export type CheckoutDraft = {
    [K in keyof CheckoutFormValues]?: CheckoutFormValues[K] extends object ? Partial<CheckoutFormValues[K]> : CheckoutFormValues[K];
};

const STORAGE_KEY = 'rc-checkout-draft';
const SAVE_DELAY_MS = 400;

export function loadCheckoutDraft(): CheckoutDraft | null {
    try {
        const raw = window.sessionStorage.getItem(STORAGE_KEY);
        if (raw === null) {
            return null;
        }
        const parsed: unknown = JSON.parse(raw);
        return typeof parsed === 'object' && parsed !== null ? parsed as CheckoutDraft : null;
    } catch {
        return null;
    }
}

export function clearCheckoutDraft(): void {
    try {
        window.sessionStorage.removeItem(STORAGE_KEY);
    } catch {
        // nedostupné úložiště není kritické
    }
}

export function useCheckoutDraftPersist(form: UseFormReturn<CheckoutFormValues>): void {
    useEffect(() => {
        let timer: number | null = null;
        const subscription = form.watch((values) => {
            if (timer !== null) {
                window.clearTimeout(timer);
            }
            timer = window.setTimeout(() => {
                try {
                    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(values));
                } catch {
                    // plné/nedostupné úložiště není kritické
                }
            }, SAVE_DELAY_MS);
        });

        return () => {
            if (timer !== null) {
                window.clearTimeout(timer);
            }
            subscription.unsubscribe();
        };
    }, [form]);
}
